module.exports = __webpack_public_path__ + "images/david-siglin-looking-happy-300w.jp2";